module.exports = __webpack_public_path__ + "static/media/Foodtopia-tablet.deaf4976.jpg";